module.exports = __webpack_public_path__ + "static/media/ID_Back.fa7182aa.png";